/**
 * 项目常量表
 */

export default {
    // localStorage
    STORAGE_KEY: {
        TOKEN: 'token',
        LAST_CLIPBOARD_DATA: 'mai-last-clipboard-data'
    },
    // cookie
    COOKIE_KEY: {
        AUTHOR: 'author'
    },
    // 状态码
    STATUS_CODE: {
        SUCCESS: 200,
        CREATED: 201,
        NOT_FOUND: 404,
        DELETED: 204,
        NOT_FOUND_SHOPPING_LIST: 3201,
        NOT_MORE_SHOPPING_LIST: 3202
    },
    // 提示文案
    MSG: {
        ERROR: {
            NETWORK_ERROR: '网络繁忙'
        },
        INFO: {
            WELCOME: '欢迎访问妈妈网'
        }
    },

    GOODS_SOURCE_TXT: {
        1: '淘宝',
        2: '天猫',
        3: '京东',
        11: '拼多多'
    },

    ACTIVITY_STATUS_TXT: {
        EXPIRED: '过期了',
        ACITIVITYING: '活动中',
        INCREATED_PRICE: '涨价了',
        SALE_OUT: '卖完了',
        NONE_COUPON: '券领完'
    },

    FM: {
        PREGNANCYHELPER: 201 // 孕育发现页入口的点位
    },

    DISLIKE_TYPE_REASON: [
        {
            label: '同类商品我不喜欢',
            type: 0,
            reason: {
                0: '其他',
                2: '商品差',
                3: '价格高/优惠少',
                4: '已购买/不需要',
                5: '重复推荐'
            }
        },
        {
            label: '该商品我不感兴趣',
            type: 1,
            reason: {
                0: '其他',
                1: '商品/链接已过期',
                2: '商品差',
                3: '价格高/优惠少',
                4: '已购买/不需要',
                5: '重复推荐'
            }
        }
    ],

    // 商品类型（注意与 tid 商品分类（品类，美妆，母婴等）区分）
    GOODS_TYPE: {
        0: '待测试商品',
        1: '人工推荐商品',
        2: '已测试商品',
        3: '猜你喜欢商品',
        9: '专题'
    },

    USER_SEX: {
        MOM: 1,
        DAD: 2,
        UNKNOW: 0
    },

    ALLOW_TB: 'MAI_ALLOW_TB_LIST',

    // 首页浮窗关闭时间key
    INDEX_FLOAT_END_TIME_KEY: 'index-float-end-time'
};
